/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import useForm from "../../shared/forms/useForm";
import moment from "moment";
import General from "./Edicion/generalRequisicion";
import { Button } from "primereact/button";
import { serialize } from "object-to-formdata";
import useApiRequisicion from "../../api/taller/useApiRequisicion";
import { TabPanel, TabView } from "primereact/tabview";
import ExGrid from "../../shared/Grid/ExGrid";
import ExColumn from "../../shared/Grid/ExColumn";
import { fechaUtc } from "../../shared/Grid/GridCellRenderers";
import requisicionValidacionEsquema from "./Edicion/requisicionValidacionEsquema";
import YupValidator from "../../shared/YupValidator";
import ReadOnlyProvider from "../../shared/forms/ReadOnlyProvider";
import Swal from "sweetalert2";

const RequisicionDetalle = ({
  requisicionId,
  onCancel,
  onSaved,
  puedeEditar,
  onRefresh,
  soloLectura,
  defaultValues,
}) => {
  const initialValues = {
    requisicion: {
      id: 0,
      fechaRequisicion: moment().startOf("day")._d,
      articulos: [],
    },
  };

  const visible = requisicionId !== null;
  const validador = new YupValidator(requisicionValidacionEsquema);

  const { values: item, setValues } = useForm(initialValues);
  const api = useApiRequisicion();
  const [errors, setErrors] = useState({});
  const normalizarRequisicion = (r) => {
    const articulosApi = r?.articulos ?? r?.Articulos ?? [];

    const articulos = (Array.isArray(articulosApi) ? articulosApi : []).map((a) => {
      const cantidad = Number(a?.cantidad ?? a?.Cantidad ?? 0);
      const comentarios = a?.comentarios ?? a?.Comentarios ?? "";

      const codigo =
        a?.codigo ??
        a?.Codigo ??
        a?.codigoArticulo ??
        a?.CodigoArticulo ??
        a?.codigoRefaccion ??
        a?.CodigoRefaccion ??
        a?.Codigo; // string

      return {
        ...a,
        codigo,
        cantidad,
        comentarios,
      };
    });

    const cantidadTotal = articulos.reduce(
      (sum, x) => sum + Number(x?.cantidad ?? 0),
      0
    );

    return {
      ...r,
      articulos,
      cantidad: Number(r?.cantidad ?? r?.Cantidad ?? cantidadTotal),

    };
  };

  const onLoad = async () => {
    setErrors({});
    if (requisicionId === 0 || requisicionId === null) {
      setValues(initialValues);
      return;
    }

    const result = await api.obtener(requisicionId);
    setValues({ requisicion: normalizarRequisicion(result) });
  };

  useEffect(() => {
    onLoad().then();
  }, [requisicionId]);

  const validarCantidadYEvidencia = (req) => {
    const errs = {};

    const cantidad = Number(req?.cantidad ?? 0);
    if (!cantidad || cantidad <= 0) {
      errs.cantidad = "La cantidad es obligatoria y debe ser mayor a 0.";
    }

    const ev = req?.evidencia;
    const evidenciaVacia =
      ev == null ||
      ev === "" ||
      (Array.isArray(ev) && ev.length === 0) ||
      (typeof ev === "object" &&
        !Array.isArray(ev) &&
        !ev.base64 &&
        !ev.url &&
        !ev.file);

    if (evidenciaVacia) {
      errs.evidencia = "La evidencia es obligatoria.";
    }

    return errs;
  };

const errorToText = (v) => {
  if (v == null) return "";
  if (typeof v === "string") return v;
  if (Array.isArray(v)) return errorToText(v[0]);
  if (typeof v === "object") {
    return (
      v.message ||
      v.mensaje ||
      v.error ||
      errorToText(v.errors) ||
      JSON.stringify(v)
    );
  }
  return String(v);
};

const mostrarAlertaValidacion = async (errs, fallbackMsg) => {
  const firstValue = Object.values(errs ?? {})[0];
  const primerError = errorToText(firstValue) || fallbackMsg;

  await Swal.fire({
    title: "Atención",
    text: primerError,
    icon: "warning",
    backdrop: true,
    allowOutsideClick: true,
    didOpen: () => {
      const container = Swal.getContainer();
      if (container) container.style.zIndex = "20000";
    },
  });
};


  const onSave = async () => {
    setErrors({});

    const yupOk = await validador.validate(item.requisicion);
    if (yupOk !== true) {
      const errs = validador.errors ?? {};
      setErrors(errs);
      await mostrarAlertaValidacion(errs, "Revisa los campos obligatorios.");
      return;
    }

    const extraErrors = validarCantidadYEvidencia(item?.requisicion);
    if (Object.keys(extraErrors).length > 0) {
      setErrors(extraErrors);
      await mostrarAlertaValidacion(extraErrors, "Revisa los campos obligatorios.");
      return;
    }

    const articulosPlanos = (item?.requisicion?.articulos ?? []).map((a) => ({
      Codigo: typeof a.codigo === "object" ? a.codigo.codigo : a.codigo,
      Descripcion: a.codigo?.descripcion ?? a.Descripcion ?? a.descripcion,
      Refaccion: a.codigo?.refaccion ?? a.Refaccion ?? a.refaccion,
      Precio: a.codigo?.precio ?? a.Precio ?? a.precio,
      UnidadesMedida: a.codigo?.unidadesMedida?.id ?? a.UnidadesMedida ?? a.unidadesMedida,
      Comentarios: a.comentarios ?? a.Comentarios,
      Cantidad: a.cantidad ?? a.Cantidad,
    }));

    const requisicionNormalizada = {
      ...item?.requisicion,
      articulos: articulosPlanos,
    };

    const formData = serialize(requisicionNormalizada, {
      indices: true,
      dotsForObjectNotation: true,
    });

    await api.guardar(formData);
    onRefresh?.();
    onSaved?.();
  };

  const handleRequisicionChange = (nuevo) => {
    setValues((prev) => ({
      ...prev,
      requisicion: {
        ...prev.requisicion,
        ...nuevo,
      },
    }));

    setErrors((prev) => {
      const next = { ...prev };
      Object.keys(nuevo ?? {}).forEach((k) => delete next[k]);
      return next;
    });
  };

  return (
    <>
      <Sidebar
        visible={visible}
        position="right"
        dismissable={false}
        className="p-sidebar-xl"
        onHide={onCancel}
        style={{ width: "1250px" }}
      >
        <TabView>
          <TabPanel header="GENERALES">
            <ReadOnlyProvider defaultReadOnly={soloLectura}>
              <General
                value={item.requisicion}
                departamentoId={defaultValues?.departamento ?? 0}
                unidadId={defaultValues?.unidadId?.id}
                estatusId={defaultValues?.estatusId}
                onChange={handleRequisicionChange}
                puedeEditar={puedeEditar}
                errors={errors}
              />
            </ReadOnlyProvider>
          </TabPanel>

          <TabPanel header={"Historial"}>
            <ExGrid data={item.requisicion?.historial ?? []}>
              <ExColumn title={"Accion"} field={"accion"} />
              <ExColumn title={"Usuario"} field={"auditUser"} />
              <ExColumn title={"Fecha"} field={"fechaUtc"} cellRenderer={fechaUtc} />
              <ExColumn title={"Comentarios"} field={"comentarios"} />
            </ExGrid>
          </TabPanel>

          <TabPanel header={"Información Unidad"}>
            <ExGrid data={item.requisicion?.unidad ? [item.requisicion.unidad] : []}>
              <ExColumn title={"Marca"} field={"marca"} />
              <ExColumn title={"Modelo"} field={"modelo"} />
              <ExColumn title={"Motor"} field={"motor"} />
              <ExColumn title={"No Serie"} field={"noSerie"} />
            </ExGrid>
          </TabPanel>
        </TabView>

        <div className="form-footer">
          <Button label="Salir" onClick={onCancel} className="p-button-outlined" />
           {!soloLectura &&
            <Button label="Guardar" type="button" onClick={onSave} />
          }
        </div>
      </Sidebar>
    </>
  );
};

export default RequisicionDetalle;